import React from 'react';

export default function PageMetaData({ 
  themes = ['🌹', '👁️', '🥀'],
  introspectionLevel = 3,
  readTime = '5-7 min read',
  style = {}
}) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexWrap: 'wrap',
      marginBottom: '20px',
      marginTop: '14px',
      marginLeft: '-6px',
      ...style
    }}>
      {/* Theme Pill */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: '#f9fafb',
        border: '1px solid #e2e8f0',
        borderRadius: '9999px',
        padding: '5px 10px',
        fontSize: '13px',
        color: '#4a5568',
        height: '34px'
      }}>
        <strong style={{ color: '#8b8b8bff', fontWeight: 600 }}>Theme</strong>
        <div style={{ display: 'flex', gap: '4px', opacity: '.9' }}>
          {themes.map((emoji, i) => (
            <span key={i} style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              border: '1px solid #cbd5e081',
              backgroundColor: '#edf2f7',
              fontSize: '13px'
            }}>
              {emoji}
            </span>
          ))}
        </div>
      </div>

      {/* Introspection Pill */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        gap: '8px', 
        backgroundColor: '#f9fafb', 
        borderRadius: '9999px', 
        padding: '5px 10px', 
        border: '1px solid #e2e8f0',
        fontSize: '13px',
        color: '#4a5568',
        height: '34px'
      }}>
        <strong style={{ color: '#8b8b8bff', fontWeight: 600 }}>Introspection Needed</strong>
        <div style={{ display: 'flex', gap: '4px' }}>
          {[1, 2, 3, 4, 5].map(i => (
            <span key={i} style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '18px',
              height: '18px',
              borderRadius: '50%',
              border: '1px solid #cbd5e0',
              backgroundColor: i <= introspectionLevel ? '#edf2f7' : 'transparent',
              fontSize: '13px',
              lineHeight: '1',
            }}>
              {i <= introspectionLevel ? '💭' : ''}
            </span>
          ))}
        </div>
      </div>

      {/* Read Time Pill */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: '#f9fafb',
        border: '1px solid #e2e8f0',
        borderRadius: '9999px',
        padding: '5px 10px',
        fontSize: '13px',
        color: '#8b8b8bff',
        height: '34px'
      }}>
        <span>{readTime}</span>
      </div>
    </div>
  );
};

